import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Stack,
  Chip,
  Alert,
} from '@mui/material';
import { API_URL } from './config';

export default function AlumniMentorInvitations() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const token = localStorage.getItem('alumniToken');

  const call = async (path, options = {}) => {
    const response = await fetch(`${API_URL}/api/alumni/mentor${path}`, {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      },
    });

    const data = await response.json();
    if (!response.ok) {
      throw Error(data.error || 'Request failed');
    }

    return data;
  };

  const load = () =>
    call('/invitations')
      .then((data) => setRows(data.rows || []))
      .catch((err) => setError(err.message));

  useEffect(() => {
    if (token) {
      load();
    }
  }, [token]);

  const respond = async (studentKey, decision) => {
    try {
      await call(`/invitations/${encodeURIComponent(studentKey)}/respond`, {
        method: 'POST',
        body: JSON.stringify({ decision }),
      });

      load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Paper
      sx={{
        p: 2,
        my: 2,
        border: '1px solid rgba(25,118,210,.2)',
        borderTop: '4px solid #F07828',
      }}
    >
      <Typography color="#1565C0" fontWeight={900}>
        Student mentorship invitations
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}

      {!rows.length && (
        <Typography sx={{ my: 2 }}>No invitations yet.</Typography>
      )}

      {rows.map((row, index) => (
        <Box
          key={`${row.StudentKey}-${index}`}
          sx={{
            p: 2,
            my: 1,
            background: index % 2 ? 'white' : '#f1f6fd',
            borderRadius: 2,
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            flexWrap="wrap"
            gap={1}
          >
            <Box>
              <Typography fontWeight={800}>
                {row.StudentName || 'Student name unavailable'}
              </Typography>
              <Typography
                variant="caption"
                sx={{ display: 'block', color: 'text.secondary' }}
              >
                Student ID: {row.StudentID || 'Not available'}
              </Typography>
              <Typography variant="body2">{row.Message}</Typography>
            </Box>

            <Chip label={row.Status} />
          </Stack>

          {row.Status === 'pending' && (
            <Stack direction="row" gap={1} mt={1}>
              <Button
                variant="contained"
                onClick={() => respond(row.StudentKey, 'accepted')}
              >
                Accept
              </Button>
              <Button
                variant="outlined"
                onClick={() => respond(row.StudentKey, 'declined')}
              >
                Decline
              </Button>
            </Stack>
          )}
        </Box>
      ))}
    </Paper>
  );
}
